import { get } from 'lodash';
export const loaderDelay = 100;

/*export const formulaForPrice = ({ min, max }, days) => {
  if (min && max && days) {
    min = parseInt(min, 10);
    max = parseInt(max, 10);
    days = parseInt(days, 10);
    if (days > 15) {
      days = 15;
    }
    return Math.ceil(parseInt(min, 10) + ((max - min) / 14) * (days - 1));
  } else {
    return '';
  }
};*/

export const formulaForPrice = (priceSettings, days) => {
  if (priceSettings && days) {
    days = parseInt(days, 10);
    if (days > 14) {
      days = 14;
    }
    return parseInt(get(priceSettings, `d${days}`), 10);
  } else {
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/utils/config.js